/*
-------------------------------------------------------------------------------------
Authors         : Alinsonorin, John Myl B., Awi, Joseph Kahl L., Gozon, Daniel Allan
Date Created    : April 30, 2025
Folder          : src/components/homepage/index
File            : Homepage.tsx
Description     : 
    This component allows the user to access the homepage of the web app.
Copyright © 2025. All rights reserved.
-------------------------------------------------------------------------------------
*/




// Imports MUI Components
import {
  Box,
  Grid,
  Link,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material"

// Import Atoms
import ButtonComp from "../../atoms/button/Button"
import Logo from "../../atoms/logo/Logo"

// Import Assets
import facebook from "../../../../assets/facebook.png"
import instagram from "../../../../assets/instagram.png"
import tiktok from "../../../../assets/tiktok.png"

// Import Molecules
import HeaderHoverableLogo from '../header/HeaderHoverableLogo'
import HeaderButtonGroup from '../header/HeaderButtonGroup'
import Icon from "../../atoms/icon/Icon"

const FooterCard = () => {

  const gridStylesContainer = {
    padding: {
      xs: "80px 30px 20px 30px", 
      sm: "80px 30px 20px 30px", 
      md: "80px 110px 20px 110px", 
      lg: "80px 110px 20px 110px", 
      xl: "80px 110px 20px 110px" 
    },
    width: "100%",
    // backgroundColor: "blue",
    "& .MuiGrid-item": {
      display: "flex",
      justifyContent: "center",
      // backgroundColor: "blue",
    },
  }
  
  const boxStylesContainer = {
    height: "100%",
    textAlign: "center",
    justifyContent: "center",
    borderRadius: "20px",
    backgroundColor: "transparent",
    padding: "20px 20px 0px 20px",
    margin: "0 10px",
  }

  const textStyles = {
    padding: "5px 10px",
  }

  return (
    <>
      {/*Grids */}
      <Grid
        container
        rowSpacing={4}
        columnSpacing={2}
        sx={gridStylesContainer}
      >

        {[
          { 
            img: "logo", 
            title: "none", 
            subtitle: "Your trusted partner in dental care since 2023.",
            link: "none",
            text1: "none", 
            text2: "none", 
            text3: "none",
            icons: false,
            img1: "none",
            img2: "none", 
            img3: "none" 
          },
          { 
            img: "none", 
            title: "Quick Links", 
            subtitle: "none",
            link: "true",
            text1: "Services", 
            text2: "About Us", 
            text3: "Contact",
            icons: false,
            img1: "none",
            img2: "none", 
            img3: "none" 
          },
          { 
            img: "none", 
            title: "Contact", 
            subtitle: "none",
            link: "false",
            text1: "2/F, 8 Banawa Centrale, R. Duterte St., Banawa, Cebu City (Above Marketplace)", 
            text2: "vsdiamonddentalclinic@gmail.com", 
            text3: "(032) 326 1584", 
            text4: "(0915) 840 6855",
            icons: false,
            img1: "none",
            img2: "none", 
            img3: "none" 
          },
          { 
            img: "none", 
            title: "Follow Us", 
            subtitle: "none",
            link: "none",
            text1: "none", 
            text2: "none", 
            text3: "none",
            icons: true,
            img1: {facebook},
            img2: {instagram},
            img3: {tiktok},
          },
        ].map((content, index) => (
            
          <Grid size={{ xs: 12, sm: 12, md: 6, lg: 3, xl: 3 }} item key={index}>

            <Box
              sx={boxStylesContainer}
            >

              {/* Logo */}
              {content.img === "logo" ? (
                <Logo
                  src={require('../../../../assets/logo.png')}/>
              ) : (
                null
              )}

              {/* Titles or Subtitles */}
              {content.title !== "none" ? (
                <Typography
                  gutterBottom
                  variant="h4"
                  component="div"
                >
                  {content.title}
                </Typography>
              ) : (
                <Typography
                  gutterBottom
                  variant="body2"
                  component="div"
                  sx={textStyles}
                >
                  {content.subtitle}
                </Typography>
              )}

              {/* Links or Texts*/}
              {content.link === "true" ? (
                <Stack
                  direction="column">
                    <Link 
                      href="/services"
                      underline="hover"
                      sx={textStyles} 
                      variant="body2"
                    >
                      {content.text1}
                    </Link>
                    <Link 
                      href="/about"
                      underline="hover"
                      sx={textStyles} 
                      variant="body2"
                    >
                      {content.text2}
                    </Link>
                    <Link 
                      href="/contact"
                      underline="hover"
                      sx={textStyles} 
                      variant="body2"
                    >
                      {content.text3}
                    </Link>
                </Stack>
              ) : content.link === "false" ? (
                <Stack
                  direction="column"
                >
                  <Typography
                    gutterBottom
                    variant="body2"
                    component="div"
                    sx={textStyles}
                  >
                    {content.text1}
                  </Typography>
                  <Typography
                    gutterBottom
                    variant="body2"
                    component="div"
                    sx={textStyles}
                  >
                    {content.text2}
                  </Typography>
                  <Typography
                    gutterBottom
                    variant="body2"
                    component="div"
                    sx={textStyles}
                  >
                    {content.text3}
                  </Typography>
                  {content.title === "Contact" && (
                    <Typography
                    gutterBottom
                    variant="body2"
                    component="div"
                    sx={textStyles}
                  >
                    {content.text4}
                  </Typography>
                  )}
                </Stack>
              ) : (
                null
              )}
              
              {/* Images */}
              {content.icons === true ? (
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{
                    justifyContent: "center"
                  }}
                >
                  <Tooltip title="Facebook" arrow>
                    <Link 
                      href="https://www.facebook.com/profile.php?id=100092482086347"
                      underline="none"
                    >
                      <Icon
                        src={content.img1.facebook}
                        size="small"/>
                    </Link>
                  </Tooltip>
                  <Tooltip title="Instagram" arrow>
                    <Link 
                      href="https://www.instagram.com/vsdiamonddentalclinic/"
                      underline="none"
                      
                    >
                      <Icon
                        src={content.img2.instagram}
                        size="small"/>
                    </Link>
                  </Tooltip>
                  <Tooltip title="Tiktok" arrow>
                    <Link 
                      href="https://www.tiktok.com/@vsdiamonddentalclinic?lang=en"
                      underline="none"
                      
                    >
                      <Icon
                        src={content.img3.tiktok}
                        size="small"/>
                    </Link>
                  </Tooltip>
                </Stack>
              ) : (
                null
              )}
              
            </Box>

          </Grid>

        ))}

      </Grid>
    </>
  )

}

export default FooterCard;